// extracted by mini-css-extract-plugin
export default {"content":"Answer-module-bf351fb57f815fc04626","name":"Answer-module-cfa22babbd01e61dffed"};